import {Store} from '../classes/store';
import {Injectable} from '@angular/core';
import {ApiLegacyService} from '../../../services/api/api.service';
import {Cluster} from '../../../resources/cluster/cluster.interface';

@Injectable({
  providedIn: 'root'
})
export class ClusterStore extends Store<Cluster> {

  /** Constructor. */
  constructor(
    private api: ApiLegacyService
  ) {
    super();
  }

}
